"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use TrashCan from foundation/TrashCan
 * @trackcomponent
 */
export const Trash = createSVGIcon(
  <>
    <path
      d="M4.28564 7.5H19.7142"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.21387 7.5H17.7853V19.0714C17.7853 19.4124 17.6498 19.7394 17.4087 19.9806C17.1676 20.2217 16.8406 20.3571 16.4996 20.3571H7.49958C7.15859 20.3571 6.83156 20.2217 6.59044 19.9806C6.34933 19.7394 6.21387 19.4124 6.21387 19.0714V7.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.78564 7.49972V6.85686C8.78564 6.00438 9.12429 5.18682 9.72709 4.58402C10.3299 3.98123 11.1474 3.64258 11.9999 3.64258C12.8524 3.64258 13.67 3.98123 14.2728 4.58402C14.8756 5.18682 15.2142 6.00438 15.2142 6.85686V7.49972"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0713 10.0713V17.1427"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9287 10.0713V17.1427"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Trash",
  { viewBox: "0 0 24 24", fill: "none" }
);
